export default __webpack_public_path__ + "static/alicjagk-6bc85c4aaa0389d9ab4e0e4efb6efe01.jpg";